import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .make();

schema.prop('personId').setType(Number);
schema.prop('projectId').setType(Number);
schema.prop('association').setType(String).setValue('other');

export default schema;
